// extracted by mini-css-extract-plugin
export var autoExpand = "_1l-b";
export var container = "_1l-a";
export var containerWidth = "_1l-8";
export var disabled = "_1l-2";
export var error = "_1l-3";
export var fullWidth = "_1l-9";
export var highlightContainer = "_1l-5";
export var inputWrapper = "_1l-0";
export var small = "_1l-1";
export var textarea = "_1l-4";
export var validatedTextarea = "_1l-6";
export var visuallyHidden = "_1l-7";